import axiosClient from '@/api/axiosClient'
import { getCurrentUser } from '@/db/indexedDB'
import { ILoanDetail } from '@/types'

export const LoanService = {
  fetchLoanDetails: async (): Promise<ILoanDetail[]> => {
    const user = await getCurrentUser()

    const response = await axiosClient.get('/loans', {
      params: {
        userId: user.id,
      },
    })

    return response.data.data
  },
}